"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * get delivery params
 *
 * @param firestore
 */
async function getDeliveryParams(firestore) {
    const path = "parametros/userapp/delivery";
    const deliveryRef = (0, firestore_1.collection)(firestore, path);
    let delivery;
    const deliveryArray = []; // TODO: get type of delivery
    try {
        delivery = await (0, firestore_1.getDocs)(deliveryRef);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    delivery.forEach(object => deliveryArray.push(object.data()));
    return deliveryArray;
}
exports.default = getDeliveryParams;
